import {Component, ElementRef, HostBinding, OnDestroy} from "@angular/core";
import {FUIFormationGroupComponent} from "../formation-groups/formation-group/formation-group.component";
import {FUIFormationService} from "../formation.service";
import {Subscription} from "rxjs";

@Component({
    selector: "fui-formation-navigation",
    styleUrls: ["./formation-navigation.component.scss"],
    templateUrl: "./formation-navigation.component.html",
    standalone: false
})
export class FUIFormationNavigationComponent implements OnDestroy {
    @HostBinding("style.top.px") offset: number;
    public group: FUIFormationGroupComponent;
    public groups: Array<FUIFormationGroupComponent> = new Array<FUIFormationGroupComponent>();

    private subscriptions: Subscription = new Subscription();

    constructor(private formationService: FUIFormationService) {
        this.subscriptions.add(this.formationService.groups$.subscribe(
            (groups) => {
                this.groups = groups;

                this.setActive(this.groups[0]);
            }
        ));

        this.subscriptions.add(this.formationService.group$.subscribe(
            (group) => {
                this.group = group;
            }
        ));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Check the currently active group against the
     * parameter group and see if it is active
     * @param group
     * @returns {boolean}
     */
    isActive(group: FUIFormationGroupComponent): boolean {
        return group === this.group;
    }

    /**
     * Set the active group only if it is not
     * the currently active group
     * @param group
     */
    setActive(group: FUIFormationGroupComponent): void {
        if (group !== this.group) {
            this.formationService.setActiveGroup(group);
        }
    }
}
